<template>
	<div class="autocomplete">
		<input
			class="input"
			type="text"
			v-model="inputValue"

			:class="isLoading ? 'loading' : ''"
      :title="inputValue"
      :disabled="disabled"

			@input="change"
			@focus="focused( true )"
			@blur="blur"
			@keydown="keys"
      v-ok

			ref="input"
      data-focus="1"
		/>
		<Icon
      :style="{ pointerEvents: disabled ? 'none' : 'unset' }"
      symbol="triangle" class="dd" size="1em" @click.native="requestForItems()"
    />
		<ul
			class="results"
			:class="{ 'active' : isShow }"
		>
			<template
				v-if="items && items.length"
			>
				<li
					v-for="( item, i ) in items"
					:key="i + '_' + item.id"
					@mousedown.stop.prevent="setItem( item, true )"
					class="item"
					:class="i === position ? 'active' : ''"
          :title="item.name"
          ref="items"
				>
					{{ item.name }}
				</li>
			</template>
			<li v-else-if="error != null" class="error">{{ $t( "Error" ) }}:<span>{{ error }}</span></li>
			<li v-else class="notfound">{{ $t( "DataNotFound" ) }}</li>
		</ul>
	</div>
</template>

<script>
import Icon from "./Icon";

export default {
	components: {
		Icon
	},
	name: "Autocompleter",

  props: {
		getItems: {
			type: Function,
			required: true
		},
		getItemsParams: {
			type: Object,
			required: false,
			default: () => { return {}; }
		},
		value: {
			type: Object,
			required: false,
			default: () => { return { id: null, name: "" } }
		},
    disabled: {
		  type: Boolean,
      default: false
    },
		debounce: {
			type: Number,
			required: false,
			default: 1000
		},
		icon: {
			type: String,
			default: "chevron"
		}
	},

	data() {
		return {
			isLoading:	false,
			isShow:		false,
			isFocused:	false,
			items:		[],
			timerId:	null,

			inputValue:	this.value.name,
			id:			this.value.id,

			position: 0,
			error:		null
		};
	},

	methods: {
		change() {
			if ( this.timerId ) clearTimeout( this.timerId );

			this.timerId = setTimeout(
				() => {
					this.timerId = null;
					this.requestForItems();
				},
				this.debounce
			);

			this.$emit( "value", this.inputValue );
			this.id = null;
		},

		async requestForItems() {
 			this.$refs.input.focus();

		  if ( this.timerId ) {
		    clearTimeout( this.timerId );
		    this.timerId = null;
      }

			this.show( false );
			this.loading( true );

			let items = null;
			try {
				items = await this.getItems( this.inputValue, this.getItemsParams );
			}
			catch ( e ) {
				this.error = "" + e.message;
			}

			this.loading( false );
			this.items = items && items.length ? items : null;

			if ( this.items ) for ( const i of this.items ) if ( ( !i.name || !( "" + i.name ).trim() ) && i.id ) i.name = i.id;

			if ( this.isFocused ) this.show( true );
		},

		focused( state ) {
			this.isFocused = state;
		},

		loading( state ) {
			this.isLoading = !!state;
		},

		show: ( () => {
			var self = null;

			function ho( e ) {
				if ( self && e && e.type ) {
					if ( e.type == "click" ) {
						if ( !self.$el.contains( e.target ) ) self.show( false );
					}
					else if ( e.type == "keydown" ) {
						const kc = e ? ( e.which ? e.which : e.keyCode ) : undefined;
						if ( kc == 27 ) self.show( false );
					}
				}
			}

			return function( state ) {
				self = this;

				document.removeEventListener( "click", ho );
				document.removeEventListener( "keydown", ho );

				if ( state ) {
					document.addEventListener( "click", ho );
					document.addEventListener( "keydown", ho );
					this.isShow = true;
				}
				else {
					this.error = null;
					this.position = 0;
					this.isShow = false;
					if ( this.timerId ) {
						clearTimeout( this.timerId );
						this.timerId = null;
					}
				}
			};
		} )(),

		clear() {
			this.inputValue = "";
			this.id = null;
		},

		set() {
			if ( this.value ) this.setItem( this.value, false, false );
			else this.clear();
		},

		blur( e ) {
			if ( e ) {
				const ca = e.explicitOriginalTarget ? e.explicitOriginalTarget : e.relatedTarget;
				if ( ca && !this.$el.contains( ca ) ) {
					this.focused( false );

					if ( this.id ) this.set();
					else this.setItem();

					this.show( false );
				}
			}
		},

		setItem( item, close, emit ) {
			if ( !item ) item = { id: null, name: "" }

			this.inputValue	= item.name;
			this.id			    = item.id;

			if ( close ) this.show( false );

			if ( emit !== false ) this.$emit( "input", { ...item, id: this.id, name: this.inputValue } );
		},

		keys( e ) {
			switch ( e ? ( e.which ? e.which : e.keyCode ) : undefined ) {
				case 13: //ENTER
					e.preventDefault();
					if ( this.isShow ) {
  					if ( this.items && this.items.length && this.position >= 0 && this.position < this.items.length ) {
	  					this.setItem( this.items[ this.position ], true );
		  			}
          }
					else this.requestForItems();
				break;

				case 38: //UP
					if ( !this.isShow ) this.requestForItems();
					else {
						e.preventDefault();
						if ( this.items && this.items.length && this.position > 0 ) {
						  this.position--;
						  this.itemToView();
            }
						return false;
					}
				break;

				case 40: //DOWN
					if ( !this.isShow ) this.requestForItems();
					else {
						e.preventDefault();
						if ( this.items && this.items.length && this.position < this.items.length - 1 ) {
						  this.position++;
						  this.itemToView();
            }
						return false;
					}
				break;
			}
		},

    itemToView() {
		  const el = this.$refs.items[ this.position ];
		  el.scrollIntoView( { block: "nearest" } );
    },

		showItems() {
			this.$refs.input.focus();
			if ( !this.isShow ) this.requestForItems();
		}
	},

	watch:   {
		value: function ( value, oldValue ) {
			this.id			= value.id;
			this.inputValue	= value.name;
		},
	},
};
</script>

<style scoped>
.autocomplete {
	position: relative;
	width: 100%;
}

.autocomplete > .input {
		padding: .2em 1em .2em .5em;
		width: 100%;
		border: 1px solid #000000;
		border-radius: 0.2em;
		box-sizing: border-box;
		font-size: inherit;
		font-family: inherit;
}

.autocomplete.disabled {
  opacity: 0.2;
  pointer-events: none;
}

.autocomplete .results {
	visibility: hidden;
	position: absolute;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
	display: inline-block;
	z-index: 1000;
	margin: 0;
	border: 1px solid #000000;
	min-height: 1em;
	max-height: 10em;
	overflow: auto;
	border-radius: 2px;
	bottom: 0;
	left: 0;
	right: 0;
	transform: translate( 0, 98% );
  background-color: #FFFFFF;
}

.autocomplete .results.active {
  visibility: visible;
}

.autocomplete .results .item {
	display: flex;
	align-items: center;
	padding: 0.5em 0.2em;
	list-style: none;
	text-align: left;
	cursor: pointer;
	font-size: inherit;
	margin: 0;
}

.autocomplete .results .item:last-child {
	border-width: 0;
}

.autocomplete .results .item.active {
	background-color: #E0E0E0;

}
.autocomplete .results .item:hover {
	background-color: #E0E0E0;
}
/*
	.autocomplete .text.loading {
		background: url(../assets/imgs/triangle.svg) no-repeat calc( 100% - 0.4em ) 50%, url(../assets/imgs/loading.svg) no-repeat 0.15em 50%;
		background-size: 1em, 1em;
	}
*/
.autocomplete .loading {
	background-image: url( ../assets/imgs/loading.svg );
	background-repeat: no-repeat;
	background-position: 0.1em 50%;
	background-size: 1em;
}

.autocomplete .results .notfound {
	display: flex;
	align-items: center;
	padding: 0.5em;
	font-weight: bold;
	list-style: none;
	text-align: left;
	cursor: default;
}

.autocomplete .results .error {
	display: block;
	padding: 0.5em;
	font-weight: bold;
	color: #A00000;
	list-style: none;
	text-align: left;
	cursor: default;
}

.autocomplete .results .error > span {
  display: block;
  margin-top: 0.5em;
	font-weight: normal;
  font-size: 0.8em;
}

.autocomplete .dd {
  position: absolute;
  right: 0;
  top: 50%;
  transform: rotate( -90deg ) translateX( 50% );
  cursor: pointer;
}
</style>
